// setGameModalPosition.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Store the shared explore game modal drag position (session-scoped) so the
 * game-list modal and the opened game modal stay at the same spot.
 * @kind action
 * @param {object} params - parameters.
 * @param {object} params.position - The drag offset from the default anchor.
 * @param {number} params.position.x - Horizontal offset in pixels.
 * @param {number} params.position.y - Vertical offset in pixels.
 * @return {Promise<Object>} Dispatched action object
 * @example
 * dispatch(setGameModalPosition({ position: { x: -40, y: -120 } }));
 */
const setGameModalPosition =
  ({ position } = {}) =>
  async dispatch => {
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['game'],
        data: {
          modalPosition: position,
        },
      },
    });
  };

export default setGameModalPosition;
